// extracted by mini-css-extract-plugin
export default {"container":"loader_container__H70Di","loader":"loader_loader__Cilih","fadeInOut":"loader_fadeInOut__lH2Nn"};